import React from 'react';
import cs from 'classnames';
import { Card, Typography, CardContent } from '@forgeglobal/design-framework';
import useStyles from './style';

interface Props {
  firstName: string;
  isVisible: boolean;
}

const NavHeader = ({ firstName, isVisible = true }: Props) => {
  const classes = useStyles();

  if (!isVisible) {
    return <div className={classes.navCardInvisible} />;
  }

  return (
    <Card
      className={cs(classes.navCard, { [classes.isInvisible]: !isVisible })}>
      <CardContent>
        <Typography color="primary" variant="h5" className={classes.headerText}>
          Hi <span title={firstName}>{firstName}</span>
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
          className={classes.headerText}>
          Welcome back!
        </Typography>
      </CardContent>
    </Card>
  );
};

export default NavHeader;
